import * as React from "react";
import { nbSippIncomePaymentDetailsLabels, nbSippIncomePaymentDetailsMessages } from "../../../Resource/Contents";
import IncomeRequired from "../../../../Common/SIPP/IncomePaymentDetails/IncomeRequired";
import RegularIncomePayment from "../../../../Common/SIPP/IncomePaymentDetails/RegularIncomePayment";
import IncomeFromPension from "./IncomeFromPension";
import { DrawdownType } from "../../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { PensionApply } from "../../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionApply";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { ChooseAssetsToSellTable } from "../../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSellTable";
import { getChooseAssetsToSellTable } from "../../../../Common/SIPP/DrawdownDetails/Helper/DrawdownDetailHelper";
import { SectionHeader } from "../../SharedComponents";
import { MoneyDisplayHelper } from "../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { RadiosEditor } from "../../../../../../../../react-core/Html/RadiosEditor";
import { ChooseAssetsToSellFor } from "../../../../Common/SIPP/DrawdownDetails/Resource/Contents";
import { ProcessType } from "../../../../../../../Shared/IST/Resource/Content";
import { processTypeEnum } from "../../../../Common/Resource/Contents";
import { setValueByKey } from "../../../../../../../Shared/Table/Utils/TableUtils";
import { IncomePaymentDestination } from "../../../../../../../../Wrap/Constants/Enums/Domain/IncomePaymentDestination";

interface IIncomePaymentProps extends IProcessComponentProps {
    data: PensionApply;
    onChange: (changes) => void;
    onIncomeChange: (changes) => void;
    isITFC: boolean;
}

interface IIncomePaymentState {
}

export class IncomePayment extends ProcessComponent<IIncomePaymentProps, IIncomePaymentState> {
    constructor(props: any) {
        super(props);
    }

    private hasDrawdown(data: PensionApply): boolean {
        return !!data?.DrawdownModel?.InstructionId;
    }

    private hasTransfer(data: PensionApply): boolean {
        return data?.PensionTransfers?.length > 0;
    }

    private isShowIncomeFromPension(data: PensionApply) {
        return (
            data?.DrawdownModel?.Income?.TargetSpecificArrangements ||
            (data?.PensionTransfers?.length > 0 &&
                data?.PensionTransfers[0]?.IncomePaymentDetails?.DrawdownIncome?.AnnualIncome
                    ?.TargetSpecificArrangements)
        );
    }

    handleAllocationChange(changes) {
        const { onChange, data } = this.props;
        let _data: typeof data = JSON.parse(JSON.stringify(data));

        for (const key in changes) {
            if (key == "IsAcrossAllAssets") {
                _data = setValueByKey(_data, `DrawdownModel.${key}`, changes[key]);
            }

            if(key=="IncomeDisinvestmentAllocations")
            {
                if (this.hasDrawdown(data)) {
                    for (const key in changes) {
                        _data = setValueByKey(_data, `DrawdownModel.${key}`, changes[key]);
                    }
                }

                if (this.hasTransfer(data)) {
                    _data.PensionTransfers = _data?.PensionTransfers?.map((e) => {
                        for (const key in changes) {
                            e = setValueByKey(e, `IncomePaymentDetails.DrawdownIncome.${key}`, changes[key]);
                        }
                        return e;
                    });
                }
            }
        }
        onChange(_data);
    }

    hasSpecifiedAssetsToSell(data: PensionApply) {
        const drawdownAsset = data?.DrawdownModel?.IncomeDisinvestmentAllocations?.length > 0;
        const transferAsset =
            data?.PensionTransfers?.length > 0 &&
            data?.PensionTransfers[0]?.IncomePaymentDetails?.DrawdownIncome?.IncomeDisinvestmentAllocations?.length > 0;
        return drawdownAsset && transferAsset;
    }

    componentDidMount(): void {
        const { data } = this.props;

        //IsAcrossAllAssets need to give default value as true
        //But when first initillize, drawdown model wasn't initillized from backend. So give the default value here
        if(!data.DrawdownModel?.IsAcrossAllAssets && !this.hasSpecifiedAssetsToSell(data))
        {
            this.handleAllocationChange({
                IsAcrossAllAssets: true,
            });
        }
    }

    public render(): JSX.Element {
        const { data, onChange, showErrorMsgPopUp, onIncomeChange, isITFC } = this.props;
        const incomePaymentAllocations = data?.PensionTransfers?.[0]?.IncomePaymentDetails?.DrawdownIncome?.AnnualIncome?.IncomePaymentAllocations ||
            data?.DrawdownModel?.Income?.IncomePaymentAllocations;
        const hasBankDestination = incomePaymentAllocations?.some(alloc => alloc.Destination == IncomePaymentDestination.BankAccount);

        return (
            <>
                <IncomeRequired
                    // SLP-157642 If income requried there will always be a PensionTransfer (business requirement)
                    // That's what the income data is alsways saved against
                    // data?.DrawdownModel?.Income? is used to store review dates.
                    data={
                        data?.PensionTransfers[0]?.IncomePaymentDetails?.DrawdownIncome?.AnnualIncome
                    }
                    // onChange={(v) => {
                    //     this.onDataChange(
                    //         (changes) => this.onDataChange(onChange, changes, data, "DrawdownModel"),
                    //         v,
                    //         data.DrawdownModel,
                    //         "Income"
                    //     );
                    // }}
                    onChange={(changes) => onIncomeChange(changes)}
                    labels={nbSippIncomePaymentDetailsLabels}
                    messages={nbSippIncomePaymentDetailsMessages}
                    onRef={(ref) => this.appendChild(ref)}
                    drawdownType={data?.DrawdownModel?.DrawdownType}
                    pensionTransfer={data?.PensionTransfers}
                    regularCrystalDifferentInital={
                        data?.DrawdownModel?.RegularCrystallisationDetails?.HasADifferentInitialAmount
                    }
                    pensionBase={data}
                    processType={processTypeEnum.NewBusiness}
                    isITFC={isITFC}
                />
                <hr />
                <IncomeFromPension
                    data={data}
                    showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                    onChange={(changes) => onChange(changes)}
                    onRef={(ref) => this.appendChild(ref)}
                    isITFC={isITFC}
                />
                <RegularIncomePayment
                    data={
                        data?.DrawdownModel?.Income ||
                        (data?.PensionTransfers?.length > 0 &&
                            data?.PensionTransfers[0]?.IncomePaymentDetails?.DrawdownIncome?.AnnualIncome)
                    }
                    onChange={(changes) => onIncomeChange(changes)}
                    labels={nbSippIncomePaymentDetailsLabels}
                    messages={nbSippIncomePaymentDetailsMessages}
                    onRef={(ref) => this.appendChild(ref)}
                    drawdownType={data?.DrawdownModel?.DrawdownType}
                    availableCash={data?.DrawdownModel?.CrystallisationDetails?.AvailableCash?.Amount}
                    taxFreeLumpSum={data?.DrawdownModel?.TaxFreeLumpSum?.Amount}
                    regularCrystallisationDetails={data?.DrawdownModel?.RegularCrystallisationDetails}
                    shouldHidePaymentMethod={!hasBankDestination}
                    pensionBase={data}
                    processType={processTypeEnum.NewBusiness}
                    isITFC={isITFC}
                    sellableAssets={getChooseAssetsToSellTable(data)}
                />
                {data?.DrawdownModel?.DrawdownType !== DrawdownType.Regular &&
                    SectionHeader("Choose assets to sell to pay income")}
                {data?.DrawdownModel?.DrawdownType !== DrawdownType.Regular && (
                    <>
                        <p>
                            Disinvestment from post-retirement to meet income payments
                            <span>
                                (
                                {MoneyDisplayHelper.getMoneyFormat({
                                    Amount: data?.DrawdownModel?.Income?.TargetSpecificArrangements
                                        ? data?.DrawdownModel?.Income?.GrossIncomePerPaymentFromPension?.Amount ||
                                          (
                                              data?.PensionTransfers?.length > 0 &&
                                              data?.PensionTransfers[0]?.IncomePaymentDetails?.DrawdownIncome
                                                  ?.AnnualIncome
                                          )?.GrossIncomePerPaymentFromPension?.Amount
                                        : data?.DrawdownModel?.Income?.GrossIncomePerPayment?.Amount ||
                                          (
                                              data?.PensionTransfers?.length > 0 &&
                                              data?.PensionTransfers[0]?.IncomePaymentDetails?.DrawdownIncome
                                                  ?.AnnualIncome
                                          )?.GrossIncomePerPayment?.Amount,
                                    Currency: CurrencyCode.GBP,
                                })}
                                )
                            </span>
                        </p>
                        <RadiosEditor
                            options={[true, false]}
                            label={"Choose asset selection method"}
                            getText={(v) => (v ? "Proportionally across all assets" : "From specified assets")}
                            onChange={(v) => {
                                this.handleAllocationChange({
                                    IncomeDisinvestmentAllocations: [],
                                    IsAcrossAllAssets: v,
                                });
                            }}
                            tooltip={
                                "If there is insufficient value in an asset at the time of the sale, we will default to disinvesting proportioanlly from the assets selected."
                            }
                            cssWrapper={"rg-inline mb-10"}
                            selected={data.DrawdownModel?.IsAcrossAllAssets ?? true}

                        />
                    </>
                )}
                {   // SLP-157642 data.DrawdownModel.IsAcrossAllAssets is does not exist when first hitting this page.
                    data.DrawdownModel?.IsAcrossAllAssets !== undefined && !data.DrawdownModel?.IsAcrossAllAssets && (
                    <ChooseAssetsToSellTable
                        modelData={data?.DrawdownModel}
                        data={
                            data?.DrawdownModel?.IncomeDisinvestmentAllocations ||
                            (data?.PensionTransfers?.length > 0 &&
                                data?.PensionTransfers[0]?.IncomePaymentDetails?.DrawdownIncome
                                    ?.IncomeDisinvestmentAllocations)
                        }
                        tableData={getChooseAssetsToSellTable(data)}
                        onRef={(ref) => this.appendChild(ref)}
                        onChange={(v) => {
                            this.handleAllocationChange({ IncomeDisinvestmentAllocations: v });
                        }}
                        reason={ChooseAssetsToSellFor.Income}
                        showErrorMsgPopUp={(msg, isShow) => showErrorMsgPopUp(msg, isShow)}
                        processType={ProcessType.NB}
                        transferData={data?.PensionTransfers}
                        pensionBase={data}
                    />
                )}
                <hr />
            </>
        );
    }
}

export default IncomePayment;
